import React, { useEffect, useState } from "react";
import api from "../../../../utils/api";
import "./AdminGallery.css";

const AdminGallery = () => {
    const [images, setImages] = useState([]);
    const [title, setTitle] = useState("");
    const [selectedFile, setSelectedFile] = useState(null);
    const [category, setCategory] = useState("Other");
    const [loading, setLoading] = useState(true);
    const [uploading, setUploading] = useState(false);

    // ✅ Fetch Images
    const fetchGallery = async () => {
        try {
            const { data } = await api.get("/gallery");
            setImages(data.data);
        } catch (error) {
            console.error("Failed to fetch gallery", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchGallery();
    }, []);

    // ✅ Upload Image
    const handleUpload = async (e) => {
        e.preventDefault();

        if (!selectedFile) {
            alert("Please select an image");
            return;
        }

        try {
            setUploading(true);

            const formData = new FormData();
            formData.append("title", title);
            formData.append("category", category);
            formData.append("image", selectedFile);

            await api.post("/gallery", formData);

            // Reset form
            setTitle("");
            setSelectedFile(null);
            setCategory("Other");

            fetchGallery();
        } catch (error) {
            console.error("Upload failed", error);
        } finally {
            setUploading(false);
        }
    };

    // ✅ Delete Image
    const handleDelete = async (id) => {
        if (!window.confirm("Delete this image?")) return;

        try {
            await api.delete(`/gallery/${id}`);
            fetchGallery();
        } catch (error) {
            console.error("Delete failed", error);
        }
    };

    if (loading) return <p className="admin-loading">Loading gallery...</p>;

    return (
        <div className="admin-gallery">
            <h1>Gallery Manager</h1>

            {/* ✅ Upload Form */}
            <form className="upload-form" onSubmit={handleUpload}>
                <input
                    type="text"
                    placeholder="Image Title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                />

                <input
                    type="file"
                    accept="image/*"
                    onChange={(e) => setSelectedFile(e.target.files[0])}
                    key={selectedFile ? selectedFile.name : "file"}
                    required
                />

                <select
                    value={category}
                    onChange={(e) => setCategory(e.target.value)}
                >
                    <option>NSS</option>
                    <option>Cultural</option>
                    <option>Workshop</option>
                    <option>Sports</option>
                    <option>Alumni</option>
                    <option>Other</option>
                </select>

                <button type="submit">
                    {uploading ? "Uploading..." : "Upload"}
                </button>
            </form>

            {/* ✅ Gallery Grid */}
            <div className="admin-gallery-grid">
                {images.map((img) => (
                    <div className="admin-gallery-card" key={img._id}>
                        <img src={img.imageUrl} alt={img.title} />

                        <div className="card-info">
                            <h3>{img.title}</h3>
                            <span className="category">{img.category}</span>

                            <button
                                className="delete-btn"
                                onClick={() => handleDelete(img._id)}
                            >
                                Delete
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AdminGallery;
